








import {Vue, Prop, Watch, Emit} from "vue-property-decorator";
import Component from "vue-class-component";
import './_details-color-picker.less';
import $ from 'jquery';
import Bloodhound from '../../../node_modules/bloodhound-js/lib/bloodhound.js'
import {translate} from "../../services/translation/translation";

@Component
export default class detailsColorPicker extends Vue {
    @Prop() colors;
    @Prop() typheadClass;
    @Prop() defaultValue;
    @Prop() inputId;

    private data :any = {
        defaultValue: 0
    };
    public isFugue = false;
    activated(){
        this.initTypheadSearch(this.colors);
        this.data.defaultValue = this.defaultValue;
        this.setDefaultColor(this.defaultValue);
        if(this.colors.length<100){
            this.isFugue = true;
        }
    }
    mounted() {
        this.initTypheadSearch(this.colors);
        this.data.defaultValue = this.defaultValue;
        this.setDefaultColor(this.defaultValue);
        if(this.colors.length<100){
            this.isFugue = true;
        }
    }

    setDefaultColor(defaultColorID){
        this.data.defaultValue = defaultColorID;
        let self = this;
        let isFound = false;
        if(defaultColorID ==""){
            this.setColor(this.typheadClass, this.colors[0]);
        }
        $.each(this.colors, function (index, color) {
            if(defaultColorID == color.id){
                isFound = true;
                self.setColor(self.typheadClass, color)
            }
        });
        if(!isFound){
            this.setColor(this.typheadClass, this.colors[0]);
        }
    }

    setColor(elementClass, color){
        $('.'+elementClass).val(color.name);
        if(color.hex == null){
            $('.'+elementClass).css("background-image", "url("+ color.image + ")");
        }else{
            $('.'+elementClass).css("background-color", "#"+color.hex);
        }
    }

    trans(key) {
        return translate(key);
    }

    initTypheadSearch(colorPalette) {
        var self = this;
        var list =[];
        colorPalette.forEach(function (value, index) {
            if(typeof value.name !== "undefined"){
                list[index] =value.name;
            }
        });

        function colorPaletteWhiteDefaults(q, sync) {
            if (q === '') {
                sync(colorPaletteBloodhound.get(list));
            }

            else {
                colorPaletteBloodhound.search(q, sync);
            }
        }


        var colorPaletteBloodhound = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            identify: function(obj) { return obj.name; },
            local: colorPalette
        });

        $('.colorSerachTyphead.'+this.typheadClass).typeahead({
                hint: false,
                highlight: true,
                minLength: 0,
                autoSelect: false,
            },
            {

                limit: 10000,
                display: 'name',
                name: 'name',
                source: colorPaletteWhiteDefaults,
                templates: {
                    suggestion: function (data) {
                        if(data.hex == null){
                            return '<div class="color-select-option"><div class="name"><p>'+data.name+'</p></div><div class="color" style="background-image: url('+ data.image + ')"></div></div>';

                        }else{
                            if(self.isFugue){
                                return '<div class="color-select-option">' +
                                            '<div class="color color-name" style="background-color: #' + data.hex + '">' +
                                                '<p>' + data.name + '</p>' +
                                            '</div>' +
                                        '</div>';
                            }else{
                                return '<div class="color-select-option"><div class="name"><p>' + data.name + '</p></div><div class="color" style="background-color: #' + data.hex + '"></div></div>';

                            }

                        }
                    },
                    empty:['<div class="color-select-option"><p>'+this.trans("not_found_color_element")+'</p></div>'].join('\n')
                }
            }).on('typeahead:select', function(e, o) {

            $(e.currentTarget).val(o.name);
            if(o.hex == null){
                $(e.currentTarget).css("background-image", "url("+ o.image + ")");
                self.onSelectedColor(self.inputId, o.id);
                self.data.defaultValue = o.id;
            }else{
                $(e.currentTarget).css("background-color", "#"+o.hex);
                self.onSelectedColor(self.inputId, o.id);
                self.data.defaultValue = o.id;
            }

            }).on('keyup',function(){
                if($(this).val().length<4){
                    // $(this).removeAttr( 'style' );
                }
            }).on('blur', function (e, o) {
                // self.setDefaultColor(self.data.defaultValue);
            });
    }


    @Emit("selectedColor")
    onSelectedColor(inputId, colorId) {
    }

    @Watch("defaultValue", {immediate: true, deep: true})
    onWatchDefaultValue(newVal, oldVal) {
        if (newVal != oldVal) {
            this.data.defaultValue = newVal;
            this.setDefaultColor(newVal);
        }
    }




}
